<template>
  <div class="cmp-wrapper">
    <basic-container>
      <query-table></query-table>
    </basic-container>
  </div>
</template>


<script>
import QueryTable from "./../../../blocks/mc-query-table/index.js";

export default {
  name: "",
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  components: {
    QueryTable
  }
};
</script>


<style lang="scss" scoped>
.cmp-wrapper {
}
</style>
